<template>
  <div class="warp-box flex-direction-box">
    <v-header>
    </v-header>

    <div class="line-box">
      <div class="line-info">
        <div class="title shadow">班组员工生产安排列表</div>
        <div class="info shadow">
          <div class="line-search">
            <div class="top">
              <div class="tit">人员列表</div>
              <el-input placeholder="请输入内容" v-model="search">
                <template slot="append">
                  <el-button type="primary" icon="el-icon-search">搜索</el-button>
                </template>
              </el-input>
            </div>
            <ul class="peoples" @dragover.stop="handleDragOver">
              <li class="people diy-prop-item" v-for="(item,index) in peoples" :data-index="index" :key="index">
                <div class="label" :class="{odd:(index+1)%2}">{{item.name}}</div>
                <div class="con">
                  <div class="node"
                       v-for="(node,index2) in item.nodes"
                       draggable="true"
                       :data-index="`${index},${index2}`"
                       :style="{width:`${width(node.duration)}%`,left:`${left(node.startTime)}%`}"
                       @dragstart.stop="changeDragStart"
                       @dragend.stop="changeDragEnd"
                       :class="node.type == 'drag'?'g-dashed':''"
                  >
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div class="line-tabel">
            <div class="tit">班组员工生产安排列表</div>
            <div class="dates">
              <div class="date" v-for="item in time">{{item}}</div>
            </div>
            <div class="times">
              <div class="date" v-for="item in time">
                <div class="time ">08:00-12:00</div>
                <div class="time ">12:30-16:30</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="line-bar">
        <div class="title shadow">订单任务列表</div>
        <div class="info shadow">
          <div class="collapse">
            <el-collapse class="o-collapse" accordion>
              <el-collapse-item v-for="(order,index) in orders" :key="index">
                <template slot="title">
                  {{order.name}}
                </template>
                <el-collapse class="p-collapse" accordion>
                  <el-collapse-item v-for="(product,index2) in order.products" :key="index2">
                    <template slot="title">
                      {{product.name}}
                    </template>
                    <ul class="orders">
                      <li v-for="(process,index3) in product.process" :key="index3" draggable="true">
                        <div class="label">{{process.label}}</div>
                        <div class="con">{{process.info}}</div>
                      </li>
                    </ul>
                  </el-collapse-item>
                </el-collapse>
              </el-collapse-item>
            </el-collapse>
          </div>
        </div>
      </div>
    </div>

    <el-dialog title="请确认" :visible.sync="dialogVisible" width="430px" center :show-close="false" class="g-dialogs">
      <div>
        <el-form ref="form" :model="form" label-width="200px" size="mini" class="g-assigndialog">
          <el-form-item label="变更员工：">
            <p>员工A</p>
          </el-form-item>
          <el-form-item label="变更工序：">
            <p>员工A</p>
          </el-form-item>
          <el-form-item label="变更数量：">
            <p>员工A</p>
          </el-form-item>
          <el-form-item label="分配数量：" class="g-form-item-input">
            <el-input v-model.trim="form.name"></el-input>
          </el-form-item>
          <el-form-item label="当前已完成任务量：">
            <p>员工A</p>
          </el-form-item>
          <el-form-item label="变更后剩余完成任务量：">
            <p>员工A</p>
          </el-form-item>
          <el-form-item label="任务开始时间："  class="g-form-item-input">
            <el-date-picker v-model="form.startTime" type="datetime" placeholder="选择日期时间"></el-date-picker>
          </el-form-item>
          <el-form-item label="任务截止时间："  class="g-form-item-input">
            <el-date-picker v-model="form.endTime" type="datetime" placeholder="选择日期时间"></el-date-picker>
          </el-form-item>
          <el-form-item label="预计工时：">
            <p>员工A</p>
          </el-form-item>
          <el-form-item label="上步工序开始时间：">
            <p>员工A</p>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="success" @click="submit">确 定</el-button>
      </span>
    </el-dialog>



  </div>
</template>

<script>
  import * as global from "../../config/mUtils";
  export default {

    data() {
      return {
        dialogVisible: false,
        form:{
          name:'',
          startTime:'',
          endTime:''
        },
        search: '',
        time: ['2018.09.13', '2018.09.14', '2018.09.15', '2018.09.14', '2018.09.15', '2018.09.14', '2018.09.15'],
        peoples: [
          {
            name: '人员1',
            nodes: [
              {
                startTime: '2018.09.13 08:00',
                endTime: '2018.09.13 12:00',
                duration: 240
              },
              {
                startTime: '2018.09.14 08:00',
                endTime: '2018.09.14 11:00',
                duration: 180
              }
            ]
          },
          {
            name: '人员2',
            nodes: [
              {
                startTime: '2018.09.14 09:00',
                endTime: '2018.09.14 10:00',
                duration: 60
              }
            ]
          },
          {
            name: '人员2',
            nodes: [
              {
                startTime: '2018.09.13 10:00',
                endTime: '2018.09.13 12:00',
                duration: 120
              }
            ]
          },
        ],
        orders: [
          {
            name: '1号订单:43216487(1/3)',
            products: [
              {
                name: '1号产品:搅拌桶1',
                process: [
                  {
                    label: '工序1',
                    info: '0/500'
                  }
                ]
              }, {
                name: '1号产品:搅拌桶1',
                process: [
                  {
                    label: '工序1',
                    info: '0/500'
                  }
                ]
              }
            ]
          },
          {
            name: '1号订单:43216487(1/3)',
            products: [
              {
                name: '1号产品:搅拌桶1',
                process: [
                  {
                    label: '工序1',
                    info: '0/500'
                  }
                ]
              }
            ]
          }
        ],
        startIndex: -1,
        parentnode: false,
        dragInfo: {type: 'drag', cont:'拖放字段到这里'},
      }
    },
    computed: {
      totalTime(){
        return this.time.length * 8 * 60 * 60
      },
    },
    mounted() {

    },
    methods: {
      width(duration){
        return (duration * 60 / this.totalTime) * 100
      },
      left(time){
        return (this.getValidTime(this.time[0] + ' 08:00', time) / this.totalTime) * 100
      },
      getValidTime(stTime, edTime){
        const startTime = new Date(stTime);
        const endTime = new Date(edTime);
        const oneDayTime = 8 * 60 * 60 * 1000;
        const dayEnd = 16 * 3600000 + 30 * 60000;
        let reduceTime = 0;//应减去的时间
        if (startTime.getHours() > 8) {//开始时间大于8点
          if (startTime.getHours() < 12) {
            reduceTime += ((startTime.getHours() - 8) * 3600000 + startTime.getMinutes() * 60000)
          } else if (startTime.getHours() === 12 && startTime.getMinutes() < 30) {//开始时间在12:00 - 12:30
            reduceTime += 4 * 3600000;
          } else {
            reduceTime += (4 * 3600000 + startTime.getHours() * 3600000 + startTime.getMinutes() * 60000 - 12 * 3600000 - 30 * 60000);
          }
        }
        if (endTime.getHours() * 3600000 + endTime.getMinutes() * 60000 - dayEnd < 0) {
          reduceTime += dayEnd - endTime.getHours() * 3600000 - endTime.getMinutes() * 60000;
          if (endTime.getHours() === 12 && endTime.getMinutes() < 30) {//结束时间在12:00 - 12:30
            reduceTime -= (12 * 3600000 + 30 * 60000 - endTime.getHours() * 3600000 - endTime.getMinutes() * 60000);
          } else if (endTime.getHours() < 12) {
            reduceTime -= 30 * 60000;
          }
        }
        if (startTime.format('yyyy-MM-dd') === endTime.format('yyyy-MM-dd')) {//同一天之内
          if (startTime.getHours() < 8 && (endTime.getHours() > 16 && endTime.getMinutes() > 30)) {
            return oneDayTime / 1000
          } else {
            return (oneDayTime - reduceTime) / 1000;
          }
        } else {//非一天之内
          const allDay = (new Date(`${endTime.getFullYear()}-${endTime.getMonth()}-${endTime.getDate()} 24:00:00`) - new Date(`${startTime.getFullYear()}-${startTime.getMonth()}-${startTime.getDate()} 00:00:00`)) / (24 * 3600000);//相差总天数
          return (oneDayTime * allDay - reduceTime) / 1000;
        }
      },
      getEndTime(sTime, vTime){

      },
      findParent(node) {
        if (node.className.indexOf('diy-prop-item') > -1) {
          this.parentnode = node
        } else {
          this.parentnode = false;
          if (node.parentNode.nodeName.toLowerCase() != 'body') {
            this.findParent(node.parentNode)
          }
        }

      },
      changeDragEnd(el) {
        const activeIndex = this.parentnode ? this.parentnode.getAttribute('data-index') : null;
        if (this.startIndex === -1){

        } else {
          let x = this.startIndex.split(','), y = activeIndex;
          this.deleteDrag();
          if (x[0] == y){
            return
          }
          let startTime,endTime;
          if (this.peoples[y].nodes.length-1 == -1) {
            startTime = this.time[0] + ' 08:00:00';
            endTime =  global.getEndtime(startTime,this.peoples[x[0]].nodes[x[1]].duration*60);
          } else {
            startTime = this.peoples[y].nodes[this.peoples[y].nodes.length-1].endTime
            endTime = global.getEndtime(startTime,this.peoples[x[0]].nodes[x[1]].duration*60);
          }
          this.peoples[y].nodes.push(...this.peoples[x[0]].nodes.splice(x[1], 1))
          this.peoples[y].nodes[this.peoples[y].nodes.length-1].startTime = startTime
          this.peoples[y].nodes[this.peoples[y].nodes.length-1].endTime = endTime
          x[0] = y
          this.startIndex = x.join(',')
        }
        this.startIndex = -1

      },
      changeDragStart(el) {
        this.startIndex = el.target.getAttribute('data-index')
      },
      handleDragOver(el){
        el.preventDefault();//重要
        el.dataTransfer.dropEffect = 'move';
        this.findParent(el.target);
        const activeIndex = this.parentnode ? this.parentnode.getAttribute('data-index') : null;
        if (activeIndex != null) {
          //console.log(x, y)    //["2", "0"] "0"   被拖拽元素索引 拖拽位置索引
          if (this.startIndex === -1) {
            this.righToLeft(activeIndex)
          } else {

            let x = this.startIndex.split(','), y = activeIndex;
            console.log(x, y)
            this.getfictitious(x, y);
          }
          /*let x = this.startIndex.split(','), y = activeIndex;
          this.getfictitious(x, y);*/





          /*this.peoples[y].nodes.push(...this.peoples[x[0]].nodes.splice(x[1], 1))
           x[0] = y
           this.startIndex = x.join(',')*/
        }
      },
      righToLeft(y){
        this.deleteDrag();
        let nodesItem = {
          startTime: '',
          endTime: '',
          duration: 120,
          type: '',
        };
        if (this.peoples[y].nodes.length-1 == -1) {
          nodesItem.startTime = this.time[0] + ' 08:00'
          nodesItem.endTime = global.getEndtime(nodesItem.startTime,nodesItem.duration*60);
        } else {
          nodesItem.startTime = this.peoples[y].nodes[this.peoples[y].nodes.length-1].endTime
          nodesItem.endTime = global.getEndtime(nodesItem.startTime,nodesItem.duration*60);
        }
        nodesItem.type = this.dragInfo.type;
        this.peoples[y].nodes.push(nodesItem);
      },
      getfictitious(x, y){
        this.deleteDrag();
        if (x[0] == y){
          return
        }
        let nodesItem = JSON.parse(JSON.stringify(this.peoples[x[0]].nodes[x[1]]));
        if (this.peoples[y].nodes.length-1 == -1) {
          nodesItem.startTime = this.time[0] + ' 08:00'
          nodesItem.endTime = global.getEndtime(nodesItem.startTime,nodesItem.duration*60);
        } else {
          nodesItem.startTime = this.peoples[y].nodes[this.peoples[y].nodes.length-1].endTime
          nodesItem.endTime = global.getEndtime(nodesItem.startTime,nodesItem.duration*60);
        }
        nodesItem.type = this.dragInfo.type;
        this.peoples[y].nodes.push(nodesItem);
      },
      deleteDrag(){
        for (let i = 0; i < this.peoples.length; i++) {
          if (this.peoples[i].nodes.length>0) {
            if (this.peoples[i].nodes[this.peoples[i].nodes.length-1].type) {
              this.peoples[i].nodes.splice(this.peoples[i].nodes.length-1,1)
            }
          }
        }
      },
      submit() {

      },
    }
  };
</script>

<style lang="scss" scoped>
  .line-box {
    user-select: none;
    flex: 1;
    display: flex;
    padding: 30px;

    .shadow {
      background-color: #fff;
      box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
      border-radius: 6px;
    }
    .title {
      font-size: 16px;
      height: 60px;
      line-height: 60px;
      text-align: center;
      color: #333;
      margin-bottom: 17px;
    }
    .line-info {
      flex: 1;
      margin-right: 17px;
      display: flex;
      flex-direction: column;
      .info {
        position: relative;
        display: flex;
        text-align: center;
        flex: 1;
        overflow: hidden;
        .line-search {
          width: 210px;
          border-right: 1px solid #ccc;
          .top {
            padding: 0 22px;
            height: 130px;
            .tit {
              line-height: 48px;
            }
          }

          .peoples {
            height: calc(100% - 130px);
            position: absolute;
            width: 100%;
            overflow: auto;
            z-index: 10;
            li {
              line-height: 40px;
              display: flex;
              width: 100%;
              .label {
                width: 209px;
                &.odd {
                  background-color: #F5F5F5;
                }
              }
              .con {
                flex: 1;
                border-bottom: 1px solid #ccc;
                position: relative;
                width: 100%;
                .node {
                  position: absolute;
                  top: 1px;
                  height: 37px;
                  line-height: 37px;
                  background-color: #9eafaf;
                  border-radius: 4px;
                }
                .g-dashed{
                  border: 1px dashed red;
                  background-color: #0AA3E7;
                }
              }
            }
          }
        }
        .line-tabel {
          flex: 1;
          .tit {
            line-height: 48px;
          }
          .dates, .times {
            display: flex;
            background-color: #D8F3EC;
            .date {
              flex: 1;
              line-height: 40px;
              border-right: 1px solid #ccc;
              border-top: 1px solid #ccc;
            }
          }
          .times {
            .date {
              display: flex;
              .time {
                flex: 1;
                border-bottom: 1px solid #ccc;
                position: relative;
                white-space: nowrap;
                &:after {
                  content: '';
                  width: 1px;
                  height: 900000px;
                  right: -1px;
                  top: 0;
                  position: absolute;
                  background-color: #ccc;
                }
              }

            }
          }
        }
      }
    }
    .line-bar {
      width: 336px;
      display: flex;
      flex-direction: column;
      .info {
        flex: 1;
        display: flex;
        .collapse {
          padding: 20px;
          width: 100%;
          overflow-y: scroll;
        }
      }
    }
  }
</style>
<style lang="scss">
  .o-collapse {
    border: none;
    .el-collapse-item__header.focusing:focus:not(:hover) {
      color: #fff;
    }
    .el-collapse-item__header {
      border: none;
      height: 42px;
      background: rgba(0, 153, 102, 1);
      border-radius: 2px;
      line-height: 42px;
      text-align: center;
      font-size: 14px;
      color: #fff;
      position: relative;
      padding-right: 20px;
      .el-collapse-item__arrow {
        font-size: 18px;
        line-height: 42px;
        position: absolute;
        right: 0;
      }
    }
    .el-collapse-item__wrap {
      border: none;
      margin-top: 2px;

    }
    .el-collapse-item__content {
      padding: 0;
      margin-bottom: 2px;
    }
    .el-collapse-item {
      margin-bottom: 2px;
    }
    .el-collapse {
      border: none;
    }
  }

  .p-collapse {
    .el-collapse-item__header {
      background-color: #4979FD;
    }
    .orders {
      margin-top: 1px;
      li {
        height: 42px;
        display: flex;
        line-height: 42px;
        border-radius: 2px;
        overflow: hidden;
        .label {
          width: 100px;
          background-color: #CECECE;
          text-align: center;
        }
        .candrag{
          background-color: #FFA200;
        }
        .con {
          background-color: #E0F3FF;
          padding: 0 13px;
          border-radius: 0px 4px 4px 0px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/基础数据管理/timeLine.vue